import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { BehaviorSubject, Observable, ObservableInput, of, throwError } from "rxjs";
import { catchError, filter, switchMap, take, tap } from "rxjs/operators";
import { AgendasService } from "./Agendas/agendas.service";
import { AuthService } from "./AuthService/auth-service.service";

@Injectable()
export class TokenInterceptor implements HttpInterceptor {

  private isRefreshing = false;
  private refreshTokenSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);

  constructor(private router: Router,public authService: AuthService, private agenda :AgendasService) { }

  intercept( request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>>   {
    if (this.authService.getJwtToken()) {
      request = this.addToken(request, this.authService.getJwtToken());
    }

    return next.handle(request).pipe(catchError(error => {
      if (error instanceof HttpErrorResponse && error.status === 401) { //Token Expired
        this.agenda._showSpinner.next(false);
        return this.refreshToken(request, next).pipe(catchError(error => {
          if (error instanceof HttpErrorResponse && error.status === 401  || error.status === 405) {
            if(!this.router.url.includes("update-contact") && !this.router.url.includes("activate-account")){
              this.authService.doLogoutUser(true)
              this.isRefreshing = false;
            }
          }
          return new Observable<HttpEvent<any>>()
        }))
    
      } else {
        return throwError(error);
      }
    }));
    // .pipe(
    //   tap(
    //     res => {
    //       debugger
    //       console.log(res); 
    //       this.isRefreshing = false; },
    //     err => { console.log(err); }
    //   ));
  }

  private addToken(request: HttpRequest<any>, token: string) {
    return request.clone({
      setHeaders: {
        'Authorization': `Bearer ${token}`
      }
    });
  }

  private refreshToken(request: HttpRequest<any>, next: HttpHandler) {
    if (!this.isRefreshing) {
      this.isRefreshing = true;
      this.refreshTokenSubject.next(null);
  
      return this.authService.refreshToken().pipe(
        switchMap((response: any) => {
          this.isRefreshing = false;
          this.refreshTokenSubject.next(response.token);
          return next.handle(this.addToken(request, response.token));
        })
      )
      
    } else {
      return this.refreshTokenSubject.pipe(
        filter(token => token != null),
        take(1),
        switchMap(jwt => {
          this.isRefreshing = false;
          return next.handle(this.addToken(request, jwt));
        }));
    }
  }
}